import Axios, { AxiosResponse } from 'axios';
import GlobalConfig from "@/GlobalConfig";
import { StringDict } from 'msal/lib-commonjs/MsalTypes';

export default class HeaderService {
    public apiUrl: string;

    public constructor() {
        this.apiUrl = GlobalConfig.UMBRACO_API_URL;
    }
	//MasterService/_umbracoMaster/0
    public async get(controller: string) : Promise<AxiosResponse<any>>{
        let headers = {
            'Content-Type': 'application/json'
        };
        return Axios.get(this.apiUrl + controller, {
            headers: headers
        })
    }
}